import { TimeType } from "../enum/time";

export const timeType = [TimeType.SLA, TimeType.OLA, TimeType.MAX_TIME]